import React, { useEffect, useState } from 'react';
import { StarIcon, QuoteIcon, ShieldCheckIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export const Testimonials: React.FC = () => {
  const testimonials = [{
    name: 'Alejandro M.',
    location: 'Madrid',
    text: 'Cuando vi que solo quedaban 200 copias, compré inmediatamente. La calidad es impresionante. Me ha inspirado a llevar mi disciplina al siguiente nivel.',
    rating: 5,
    highlight: 'Compra verificada'
  }, {
    name: 'Carlos D.',
    location: 'Barcelona',
    text: 'Este no es un simple ebook, es una experiencia transformadora. Las ilustraciones exclusivas y el contenido sobre la mentalidad de CR7 valen cada céntimo.',
    rating: 5,
    highlight: 'Edición #37/200'
  }, {
    name: 'María L.',
    location: 'Valencia',
    text: 'Lo compré como regalo para mi hijo y ahora toda la familia lo está leyendo. La sección sobre la disciplina diaria ha cambiado nuestra rutina por completo.',
    rating: 5,
    highlight: 'Compra verificada'
  }, {
    name: 'Roberto F.',
    location: 'Sevilla',
    text: 'La calidad del contenido es excepcional. No solo habla de sus logros, sino de la mentalidad detrás de ellos. Recomendado para cualquier fan o persona que busque inspiración.',
    rating: 5,
    highlight: 'Edición #112/200'
  }, {
    name: 'Lucía G.',
    location: 'Bilbao',
    text: 'Las ilustraciones son obras de arte. Cada página transmite la esencia de CR7. Me alegro de haber conseguido una copia antes de que se agoten.',
    rating: 5,
    highlight: 'Compra verificada'
  }, {
    name: 'Javier P.',
    location: 'Málaga',
    text: 'Increíble relación calidad-precio. El certificado numerado le da un valor especial. Un tesoro para cualquier coleccionista o fan de Cristiano.',
    rating: 5,
    highlight: 'Compra verificada'
  }];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(3);
  const nextTestimonial = () => {
    setCurrentIndex(prevIndex => prevIndex + 1 >= testimonials.length - (visibleCount - 1) ? 0 : prevIndex + 1);
  };
  const prevTestimonial = () => {
    setCurrentIndex(prevIndex => prevIndex - 1 < 0 ? testimonials.length - visibleCount : prevIndex - 1);
  };
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setVisibleCount(1);
      } else if (window.innerWidth < 1024) {
        setVisibleCount(2);
      } else {
        setVisibleCount(3);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return <section className="py-20 relative overflow-hidden" data-id="element-312">
      <div className="absolute -top-40 -left-40 w-80 h-80 bg-gradient-to-br from-[#E0B84C]/10 to-[#E0B84C]/5 rounded-full blur-3xl" data-id="element-313"></div>
      <div className="text-center mb-12 relative z-10" data-id="element-314">
        <div className="inline-flex items-center justify-center p-2 bg-[#0A0A0A] border border-[#E0B84C]/30 rounded-full mb-6" data-id="element-315">
          <div className="px-4 py-1 bg-gradient-to-r from-[#E0B84C]/20 to-[#E0B84C]/20 text-[#E0B84C] text-sm font-medium rounded-full flex items-center" data-id="element-316">
            <StarIcon className="w-4 h-4 mr-1" data-id="element-317" /> FANS SATISFECHOS{' '}
            <StarIcon className="w-4 h-4 ml-1" data-id="element-318" />
          </div>
        </div>
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-319">
          La Comunidad de Fans Exclusivos
        </h2>
        <p className="text-lg text-[#CFCFCF] max-w-3xl mx-auto" data-id="element-320">
          Únete a los fans que ya están experimentando la mentalidad CR7 desde
          dentro.
          <span className="text-[#E0B84C] font-medium" data-id="element-321">
            {' '}
            Solo quedan {Math.floor(Math.random() * 50) + 100} copias
            disponibles.
          </span>
        </p>
      </div>
      <div className="relative z-10 max-w-6xl mx-auto px-4" data-id="element-322">
        <div className="flex overflow-hidden relative" data-id="element-323">
          <div className="flex transition-transform duration-500 ease-in-out" style={{
          transform: `translateX(-${currentIndex * (100 / visibleCount)}%)`
        }} data-id="element-324">
            {testimonials.map((testimonial, index) => <div key={index} className="w-full md:w-1/2 lg:w-1/3 flex-shrink-0 p-3" data-id="element-325">
                <div className="bg-gradient-to-b from-[#1A1A1A] to-[#0A0A0A] border border-[#E0B84C]/30 rounded-xl p-6 relative h-full" data-id="element-326">
                  <div className="absolute -top-3 -right-3 bg-[#E0B84C] text-black text-xs font-bold px-3 py-1 rounded-full" data-id="element-327">
                    {testimonial.highlight}
                  </div>
                  <QuoteIcon className="w-10 h-10 text-[#E0B84C]/20 absolute top-4 right-4" data-id="element-328" />
                  <div className="flex mb-4" data-id="element-329">
                    {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-[#E0B84C] fill-[#E0B84C]" data-id="element-330" />)}
                  </div>
                  <p className="text-[#CFCFCF] italic mb-4" data-id="element-331">
                    "{testimonial.text}"
                  </p>
                  <div className="flex items-center mt-auto" data-id="element-332">
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#E0B84C] to-[#FFD700] flex items-center justify-center text-black font-bold" data-id="element-333">
                      {testimonial.name.charAt(0)}
                    </div>
                    <div className="ml-3" data-id="element-334">
                      <p className="font-medium" data-id="element-335">{testimonial.name}</p>
                      <p className="text-sm text-gray-400" data-id="element-336">
                        {testimonial.location}
                      </p>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
        {/* Navigation buttons */}
        <button onClick={prevTestimonial} className="absolute top-1/2 left-0 -translate-y-1/2 bg-[#0A0A0A] border border-[#E0B84C]/30 rounded-full p-2 text-[#E0B84C] hover:bg-[#E0B84C]/10 transition-colors duration-300 z-20" data-id="element-337">
          <ChevronLeftIcon className="w-6 h-6" data-id="element-338" />
        </button>
        <button onClick={nextTestimonial} className="absolute top-1/2 right-0 -translate-y-1/2 bg-[#0A0A0A] border border-[#E0B84C]/30 rounded-full p-2 text-[#E0B84C] hover:bg-[#E0B84C]/10 transition-colors duration-300 z-20" data-id="element-339">
          <ChevronRightIcon className="w-6 h-6" data-id="element-340" />
        </button>
      </div>
      <div className="mt-12 p-6 border border-[#E0B84C]/30 rounded-xl bg-[#0A0A0A]/50 flex items-center justify-between max-w-3xl mx-auto relative z-10" data-id="element-341">
        <div className="flex items-center" data-id="element-342">
          <ShieldCheckIcon className="w-10 h-10 text-[#22C55E] mr-4" data-id="element-343" />
          <div data-id="element-344">
            <h3 className="font-bold text-lg" data-id="element-345">100% Garantía de Satisfacción</h3>
            <p className="text-gray-400" data-id="element-346">
              Acceso instantáneo • Soporte prioritario • Experiencia premium
            </p>
          </div>
        </div>
        <div className="text-2xl font-bold text-[#E0B84C]" data-id="element-347">
          {Math.floor(Math.random() * 100) + 900}+{' '}
          <span className="text-sm font-normal text-gray-400" data-id="element-348">descargas</span>
        </div>
      </div>
    </section>;
};